export const API_URL = 'https://api.quantzone.org'
export const API_URL_LOCAL = 'http://localhost:3000'


export const TOKEN_TIME = 'tokenTime'

export const TOKEN_TIME_VALUE = 2 * 60 * 60 * 1000
